import React from 'react';
import ProductModal from '../../components/Modal/ProductModal';
import HeaderSeven from '../../components/Header/HeaderSeven';
import ShopSidebarMain from './ShopSidebarMain';
import Footer from '../../components/Footer';

const ShopSidebar = () => {
  return (
    <>
      <ProductModal />

      <HeaderSeven />

      <ShopSidebarMain />

      <Footer />
    </>
  );
};

export default ShopSidebar;
